import { render, staticRenderFns } from "./result.vue?vue&type=template&id=bfc1f6e8&scoped=true"
import script from "./result.vue?vue&type=script&lang=ts&setup=true"
export * from "./result.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./result.vue?vue&type=style&index=0&id=bfc1f6e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc1f6e8",
  null
  
)

export default component.exports